export const steps = [
  {
    id: 0,
    imageUrl: 'images/bb/authorize-sms/sms-woman.png',
    alt: 'Mulher olhando o celular na mão',
    label: '',
    title: 'É necessário autorizar o SMS para continuar',
    subtitle: 'Saiba como cadastrar um número de telefone no app do Banco do Brasil para receber SMS e continuar com a solicitação do seu cartão.',
  },
  {
    id: 1,
    imageUrl: 'images/bb/authorize-sms/step-1.svg',
    alt: 'A imagem é a parte de uma tela de celular onde contém a tela incial do aplicativo do banco, está escrito: "Que bom você por aqui", e o nome "Maria Silva" e os seus respectivivos dados bancários em foco.',
    label: 'Passo 1 de 6',
    title: 'Acesse sua conta no app do Banco do Brasil',
    subtitle: 'Ao abrir o app do Banco do Brasil, utilize seus dados e senha para acessar o app.',
  },
  {
    id: 2,
    imageUrl: 'images/bb/authorize-sms/step-2.svg',
    alt: 'A imagem é a parte de uma tela de celular. Há uma tela do aplicativo contendo uma busca onde a palavra "Sms" está sendo pesquisada. Abaixo do campo de busca, que está circulado em uma cor amarela, há a sessão de "serviços", e o item "Aderir aos SMS" está circulado em tom amarelo.',
    label: 'Passo 2 de 6',
    title: 'No Menu, vá até a busca e digite  “SMS”',
    subtitle: <p>Toque na <strong>opção ”Aderir ao SMS”</strong> na lista de serviços encontrados na busca.</p>,
  },
  {
    id: 3,
    imageUrl: 'images/bb/authorize-sms/step-3.svg',
    alt: 'A imagem é a parte de uma tela de celular. Há escrito na tela "LI E CONCORDO COM O TERMO DE ADESÃO:", abaixo há um botão, na cor amarela, escrito "SIM" circulado em uma cor amarela. E abaixo um botão, na cor azul, escrito "NÃO".',
    label: 'Passo 3 de 6',
    title: 'Leia e aceite o termo de adesão',
    subtitle: <p>No final da página, <strong>toque em ”Sim”</strong> para aceitar o termo.</p>,
  },
  {
    id: 4,
    imageUrl: 'images/bb/authorize-sms/step-4.svg',
    label: 'Passo 4 de 6',
    alt: 'A imagem é a parte de uma tela de celular. Há escrito como titúlo da página "Adesão - SMS" e um icone de flecha no lado esquedo. Abaixo há uma seção escrita "DADOS DO CELULAR", com dois botões um abaixo do outro: o primeiro escrito "DDD" e o segundo escrito "Telefone".',
    title: 'Digite seu DDD e Telefone',
    subtitle: <p>Após digitar os dados do celular <strong>busque a opção ”Sms gratuito - cartão”</strong>.</p>,
  },
  {
    id: 5,
    imageUrl: 'images/bb/authorize-sms/step-5.svg',
    alt: 'A imagem é a parte de uma tela do celular. Há escrito em destaque e circulado em cor amarela a frase: "Sms gratuito - cartão" e um botão radio selecionado na cor azul.',
    label: 'Passo 5 de 6',
    title: 'Busque e habilite a opção de ”Sms gratuito - cartão”',
    subtitle: <p>Toque no botão <strong>"Continuar”</strong> no fim da lista de opções.</p>,
  },
  {
    id: 6,
    imageUrl: 'images/bb/authorize-sms/step-6.svg',
    alt: 'A imagem é a parte de uma tela do celular. Há um botão, na cor amarela, escrito "CONFIRMA" circulado na cor amarela.',
    label: 'Passo 6 de 6',
    title: 'Confira seus dados e toque em ”Confirma” para finalizar',
    subtitle: `Após finalizar a autorização de SMS volte aqui para continuar a solicitação do seu Ourocard Fácil.`,
  },
  {
    id: 7,
    imageUrl: 'images/bb/authorize-sms/sms-woman.png',
    alt: 'Mulher olhando o celular na mão',
    label: '',
    title: 'É necessário autorizar o SMS para continuar',
    subtitle: 'Agora que você já sabe como é, vá até o app do Banco do Brasil, siga os passos apresentados e cadastre um número de telefone para receber SMS.',
  },
]